import React, { useEffect, useState } from 'react';
import ComplaintMessage from '../../../../../models/ComplaintMessage';
import Pagination from '../../../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper, Tooltip, IconButton, Box } from '@mui/material';
import PaginationButtons from '../../../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { complaintMessageStatusTypeToDescription } from '../..';
import ComplaintMessageUpsert from '../ComplaintMessageUpsert';
import { AttachFile } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { downloadComplaintMessageFile } from '../../../../../actions/complaint/complaintMessageDownloadFile'
import Complaint from '../../../../../models/Complaint';

export interface Row {
  data: ComplaintMessage
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  loading: boolean;
  id: string;
  complaint: Complaint;
  pagination?: Pagination;
  fromIn?: boolean;
  owner?: number;
  viewClientInfo?: boolean;
  onClickChangeStatus?: (complaintMessage: ComplaintMessage | undefined, complaint: Complaint, updateStatusComplaint: boolean) => void;
  onChangePage?: (page: number) => void;
}

const ComplaintMessages: React.FC<Props> = (props) => {
  const { t } = useTranslation('complaint')
  const dispatch = useDispatch()
  const [downloading, setDownloading] = useState<number>(-1)
  const [updateStatusAsRead, setUpdateStatusAsRead] = useState<boolean>(false)

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  const searchAndUpdateUnreadStatus = async () => {
    if ( !props.viewClientInfo ) {
    //if (props.viewClientInfo === undefined) {
      if (!props.rows.length)
        props.complaint && props.complaint.assignedToId && props.onClickChangeStatus && props.onClickChangeStatus(undefined, props.complaint, props.complaint.assignedToId === props.owner)
      else {
        props.rows.forEach(row => {
          if (props.owner !== undefined && Number(props.id) === row.data.complaintId && row.data.ownerId !== props.owner && row.data.status === 'U') {
            props.complaint.assignedToId && props.onClickChangeStatus && props.onClickChangeStatus(row.data, props.complaint, props.complaint.assignedToId! === props.owner)
          }
        })
      }
      setUpdateStatusAsRead(true)
    }
  
  }
  useEffect(() => {
    if (!updateStatusAsRead && !props.loading)
      searchAndUpdateUnreadStatus()
    // eslint-disable-next-line
  }, [updateStatusAsRead, props.loading])


  const downloadFileComplaintMessage = async (complaintMessage: ComplaintMessage) => {
    if (complaintMessage.fileId && complaintMessage.id) {
      try {
        setDownloading(complaintMessage.id)
        await dispatch(downloadComplaintMessageFile(complaintMessage.complaintId, undefined, complaintMessage.id,
          (file: any) => {

            const url = URL.createObjectURL(new Blob([file], { type: 'application/pdf' }))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              complaintMessage.fileName ? complaintMessage.fileName : `${complaintMessage.message}.pdf`
            );
            document.body.appendChild(link);
            // Start download
            link.click();

            URL.revokeObjectURL(url);
          }))
        setDownloading(-1)
      }
      catch {
      }
    }
  }

  return (
    <Paper style={{ borderRadius: "10px", margin: props.fromIn ? "-10px" : "10px" }}>
      {!props.fromIn && <ISTableTitle title={t('complaintTrackingTitle')} />}
      <Table style={{ whiteSpace: "nowrap", overflow: "hidden" }} size="medium" >
        <TableHead>
          <TableRow selected={true}>
            <ISTableHeaderCell align="center">{t('datetime')}</ISTableHeaderCell>
            <ISTableHeaderCell align="center">{t('message')}</ISTableHeaderCell>
            <ISTableHeaderCell align="center">{t('status')}</ISTableHeaderCell>
            <ISTableHeaderCell align="center"></ISTableHeaderCell>
            <ISTableHeaderCell>{t('ownerDoneName')}</ISTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!props.loading && props.rows.map((row, index) => {
            const align = row.data.ownerId === props.owner ? true : false // "right" : "left"
            return <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{ cursor: 'default' }}
            //onClick={(e) => { e.stopPropagation(); props.onClickChangeStatus && row.data.ownerId !== props.owner && props.onClickChangeStatus(row.data) }}
            >
              <TableCell align='center'>{moment(new Date(row.data.date)).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY HH:mm ')}</TableCell>
              {/*<TableCell align={align} style={{  fontWeight: row.data.status === 'U' ? 'bold' : 'default', maxWidth: '900px', textWrap:'wrap' }}>{row.data.message}</TableCell>*/}
              {/*<TableCell 
                 style={{ paddingLeft: align ? '150px' : 'inherit', paddingRight: align ? 'inherit' : '150px', 
                 fontWeight: row.data.status === 'U' ? 'bold' : 'default', maxWidth: '900px', textWrap:'wrap' }}>
                  {row.data.message}
              </TableCell>*/}
              <TableCell
                style={{
                  paddingLeft: align ? '150px' : 'inherit', paddingRight: align ? 'inherit' : '150px',
                  fontWeight: row.data.status === 'U' ? 'bold' : 'default', maxWidth: '900px', textWrap: 'wrap'
                }}>
                <Box style={{ padding: '10px', display: 'flex', justifyContent: align ? 'flex-end' : 'flex-start' }}>
                  <Paper elevation={2} style={{ padding: '10px' }}> {/* style={{ padding: '10px', display: 'flex', justifyContent: align ? 'flex-end' : 'flex-start'}}>*/}
                    {row.data.message}
                  </Paper>
                </Box>
              </TableCell>
              <TableCell align="center">{t(complaintMessageStatusTypeToDescription(row.data.status))}</TableCell>
              <Tooltip title={row.data.fileName ? row.data.fileName : ''}>
                <TableCell align="center">{row.data.fileId ?
                  <IconButton color="secondary"
                    onClick={(e) => { e.stopPropagation(); downloadFileComplaintMessage(row.data) }}>
                    {downloading === row.data.id ? <CircularProgress size={15} /> : <AttachFile fontSize="small" />}
                  </IconButton>
                  : ''}</TableCell>
              </Tooltip>
              <TableCell>{row.data.ownerName}</TableCell>
            </ISTableRow>
          }
          )}
        </TableBody>
      </Table>
      {props.loading &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={25} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
      {!props.loading && props.complaint && props.complaint.dateClose === null && !props.viewClientInfo &&
        <ComplaintMessageUpsert />
      }

    </Paper>
  );
}

export default ComplaintMessages
